class CompanyFinder {
  constructor() {

    if(document.querySelector('.company-finder') != null && document.querySelector('.company-finder') != undefined) {
      this.setEvents();
    }

    if(document.querySelector('.body__links') != null && document.querySelector('.body__links') != undefined) {
      this.setEventsAnchors();
    }

  }
  
  setEvents() {
    var companyFinder = document.querySelectorAll('.company-finder');
    var searchAreas = document.querySelectorAll('.search__filter');
    var companyFinderOverlay = document.querySelectorAll('.company-finder__overlay');

    if(typeof(companyFinder) != 'undefined' && companyFinder != null) {

      function resetCompanyFinder() {
        searchAreas.forEach(searchArea => {
          var overlay = searchArea.querySelector('.company-finder__overlay');
          overlay.parentNode.classList.remove("active");
          overlay.nextElementSibling.value = '';
        });
      }

      companyFinderOverlay.forEach(overlay => {
        overlay.addEventListener("click", function(event) {
          event.preventDefault();
          resetCompanyFinder();
        });
      });

      companyFinder.forEach(company => {
        company.addEventListener("keyup", function(event) {
          var search = event.target.value;

          if (search.length > 0) {
            company.parentNode.classList.add("active");
          } else {
            company.parentNode.classList.remove("active");
          };
        });
      });

      //reset companyFinder

      var newComplainBtns = document.querySelectorAll('.filter__add-company');

      newComplainBtns.forEach(btn => {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          resetCompanyFinder();
        });
      });
    }     


  }

  setEventsAnchors() {
    var howItWorkAnchor = document.querySelectorAll('.how-it-work___anchor');
    var howItWorkPosition = document.getElementById('how-it-work').offsetTop;

    var faqAnchor = document.querySelectorAll('.faq__anchor');
    var faqPosition = document.getElementById('faq-complain').offsetTop;

    if(typeof(howItWorkAnchor) != 'undefined' && howItWorkAnchor != null) {

      howItWorkAnchor.forEach(anchor => {
        anchor.addEventListener("click", function(event) {
          event.preventDefault();

          window.scroll(0, howItWorkPosition - 90);

        });
      });
      
    }

    if(typeof(faqAnchor) != 'undefined' && faqAnchor != null) {

      faqAnchor.forEach(anchor => {
        anchor.addEventListener("click", function(event) {
          event.preventDefault();

          window.scroll(0, faqPosition - 90);

        });
      });
      
    }

  }
    
}

$(document).ready(function() {
  const companyFinder = new CompanyFinder();
});
